import { InfluencerSection } from '@src/quince-components/src'
import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import BundlePageSectionProps from '@src/quince-site-pdp/src/domains/BundlePageSectionProps'
import ProductPageSectionProps from '@src/quince-site-pdp/src/domains/ProductPageSectionProps'

import styles from './socialPhotos.module.scss'

function InfluencerSectionContentFullWrapper(props: ProductPageSectionProps | BundlePageSectionProps) {
  const influencerSectionData = props.sectionData[CUSTOM_SECTION_TYPE.INFLUENCER]
  const influencerSection = influencerSectionData.influencerSection
  const headingRichTextProps = influencerSectionData.headingRichTextProps
  const descriptionRichTextProps = influencerSectionData.descriptionRichTextProps

  if (
    headingRichTextProps ||
    descriptionRichTextProps ||
    (influencerSection?.influencers && influencerSection.influencers.length > 0)
  ) {
    return (
      <InfluencerSection
        headingRichText={headingRichTextProps}
        descriptionRichText={descriptionRichTextProps}
        influencerDetailList={influencerSection?.influencers || []}
        className={styles.influencerSection}
      />
    )
  }

  return null
}

export default InfluencerSectionContentFullWrapper
